<!doctype html>
<html lang="en">
  <head>
  	<title>RA REGISTER</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

	<link href="https://fonts.googleapis.com/css?family=Lato:300,400,700&display=swap" rel="stylesheet">

	<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="../../../../assets/css/style.css">
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css"
   />
  <script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js"></script>

	</head>
	<body>
	<section class="ftco-section">
		<div class="container" style="bottom:90px; position: relative;">
		
			<div class="row justify-content-center">
				<div class="col-md-6 col-lg-5">
					<div class=" p-4 p-md-5">
                <!-- Alert message after Inscription -->
                <div *ngIf="errtext !='' && reconnecte!=true" class="alert alert-danger" style="text-align:center ; font-weight: normal;">
                  <small>
                    {{errtext}}
                  </small>
                </div>
                <div *ngIf="errtext !=''  &&  reconnecte" class="alert alert-success" style="text-align: center;font-weight: normal;">
                  <small>
                    {{errtext}}
                  </small>
                </div>
		      	<!-- <div class="icon d-flex align-items-center justify-content-center">
		      		<span class="fa fa-user-o"></span>
		      	</div> -->
            <div class=" d-flex align-items-center justify-content-center "> 
		      		
              <img src="/assets/img/whiteicon.png " class = "logo">
    
                </div>
              <div class=" d-flex align-items-center justify-content-center "> 
              <div class="hh"  >Robo-Advisor</div>
              
                </div>
        
          <!-- Reactive Form start here  -->
      <div class="scr">
				<form class="login-form" [formGroup]="registerForm" (ngSubmit)="onRegistre()" >
		      	<div class="form-group">
		      		        <input type="text" class="form-control rounded-left" formControlName="username"  placeholder="saisissez le nom d'utilisateur">
                      <div *ngIf="username.touched && username.hasError('required')" class="invalid-feedback d-block" >Nom d'utilisateur est obligatoire </div>
              </div>
              <div class="form-group">
                    <input type="email" class="form-control rounded-left"  formControlName="email" pattern="[^ @]*@[^ @]*" placeholder="saisissez l'adresse courriel">
                    <div *ngIf="email.touched && email.errors?.required" class="invalid-feedback d-block">Adresse courriel est obligatoire</div>
                    <div *ngIf="email.touched && email.errors?.email" class="invalid-feedback d-block" >Adresse courriel invalide</div>
              </div>
        
              <div class="form-group">
                <input type="tel" class="form-control rounded-left"   formControlName="tel" placeholder="saisissez le numéro du télephone" >
                <div *ngIf="tel.touched && tel.hasError('required')" class="invalid-feedback d-block">
                  Numéro de téléphone est obligatoire</div>
                <div *ngIf="tel.touched && tel.errors?.minlength" class="invalid-feedback d-block">
                    Le numéro de téléphone se compose de  8 chiffres.
                </div>
                
              </div>

	            <div class="form-group">
	              <input type="password"  class="form-control rounded-left "  formControlName="password" placeholder="saisissez le mot de passe" minlength="8"  >
                  <div *ngIf="password.touched && password.hasError('required')" class="invalid-feedback d-block">Mot de passe est obligatoire</div>
                  <div *ngIf="password.touched && password.errors?.minlength" class="invalid-feedback d-block">
                     Le mot de passe doit comporter au moins 8 caractères.
                 </div>
                 <div *ngIf="password.touched && password.errors?.pattern" class="invalid-feedback d-block">
                   Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial
                  </div>
                </div>

               
                <div class="form-group">
                    <input type="password" class="form-control rounded-left"  formControlName="confirmpassword" placeholder="Confirmez le mot de passe

                    " minlength="8" >
                    <div *ngIf="confirmpassword.touched && confirmpassword.hasError('required')" class="invalid-feedback d-block" >Mot de passe de confirmation est obligatoire </div>
                    <div *ngIf=" confirmpassword.touched && confirmpassword.hasError('mismatch')" class="invalid-feedback d-block">
                    Le mot de passe de confirmation ne correspond pas au mot de passe saisi 
                </div>
                </div>
        

                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="invitationCheckbox" (change)="toggleInvitationCode()">
                    <label class="form-check-label" for="invitationCheckbox" style="color:white">
                      J'ai une invitation
                    </label>
                  </div>
                </div>
                
                <div class="form-group" *ngIf="showInvitationCode">
                  <input type="text" class="form-control rounded-left"  formControlName="invitationCode" placeholder="Code d'invitation">
                </div>
	           <div class="form-group">
	            	<button type="submit"  [disabled]="registerForm.invalid" class="btn btn-primary rounded submit p-3 px-5" style="color: white">S'INSCRIRE</button>
	            </div>
                <div class="form-group md-d-flex">
                    <div class=" d-flex justify-content-center links" style="margin-top: 110px; color: white;">
                        Vous avez un compte ? <a [routerLink]="['/']" routerLinkActive="router-link-active" style="font-weight: bold;color:white"> CONNEXION</a>
                     </div>
                 </div>
	          </form>
          </div>
            <!-- Form End here  -->

	        </div>

			</div>
			</div><!-- télephone -->
     
		</div>
	</section>
  <script>
    const phoneInputField = document.querySelector("#phone");
    const phoneInput = window.intlTelInput(phoneInputField, {
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });
  </script>
	<script src="../../../../assets/js/jquery.min.js"></script>
  <script src="../../../../assets/js/popper.js"></script>
  <script src="../../../../assets/js/bootstrap.min.js"></script>
  <script src="../../../../assets/js/main.js"></script>
</body>
</html>

